import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';

interface DialogStandardProps {
  children: React.ReactNode;
  open: boolean;
  title: React.ReactNode;
  handleClose: () => void;
  info?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}
const DialogStandard = ({
  children,
  open,
  title,
  handleClose,
  info,
  size = 'sm',
}: DialogStandardProps) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={size}
      onClose={handleClose}
      aria-labelledby="standard-dialog"
      aria-describedby="standard-dialog-description"
      PaperProps={{ sx: { overflowY: 'hidden' } }}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
    >
      <DialogTitle
        id="standard-dialog"
        sx={{ fontSize: '18px', display: 'flex', alignItems: 'center' }}
        color="primary"
      >
        {title}
        {info && (
          <Box
            component="a"
            href={info}
            target="_blank"
            rel="noreferrer"
            title={info}
            sx={{ ml: 2, display: 'flex', alignItems: 'center' }}
          >
            <InfoOutlinedIcon color="secondary" fontSize="small" />
          </Box>
        )}
      </DialogTitle>
      <DialogContent
        sx={{
          paddingTop: '8px !important',
          width: '100%',
        }}
      >
        {children}
      </DialogContent>
      <DialogActions>
        <IconButton
          sx={{
            position: 'absolute',
            top: '8px',
            right: '8px',
          }}
          onClick={handleClose}
        >
          <HighlightOffOutlinedIcon fontSize="small" />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
};

export default DialogStandard;
